import getRequestBodyFields from '../view/getRequestBodyFields';
import CardItem from 'txp-data/lib/schema/viewSchema/CardItem';

/**
 * For logging purposes we are interested in which fields were modified
 */
export default function getCustomDataForDirtyFields(
    cardItem: CardItem,
    summaryField: string,
    detailsField: string
): any {
    const requestedBodyFields = getRequestBodyFields(cardItem, summaryField, detailsField);
    return {
        summary: !!requestedBodyFields.summaryEditableField,
        location: !!requestedBodyFields.detailsEditableField,
    };
}
